module.exports = __webpack_public_path__ + "img/freesia.92031b8e.jpg";